import styled from 'styled-components';

export const SingleSelectionFilterWrapper = styled.div`
  border-radius: 4px;
  white-space: nowrap;
`;

export const SingleSelectionCheckboxContainer = styled.div`
  width: 100%;
  height: 100%;

  span {
    color: ${({ theme }) => theme.palette.grey1100};
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }
`;
